import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '1174170387848123';
const MetaPixel = () => {
  useEffect(() => {
    // Ensure window is defined
    if (typeof window === 'undefined') return;
    // Define fbq if it doesn't exist
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
    }
    // Load the script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize once script is loaded
    script.onload = () => {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    };
    return () => {
      // Cleanup if needed
      document.head.removeChild(script);
    };
  }, []);
  return <noscript data-id="element-252">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-253" />
    </noscript>;
};
export default MetaPixel;